import React from 'react';
import { Box, Typography, Checkbox } from '@mui/material';
import { SelectQuestion as SelectQuestionType } from '../../interfaces';
import { useStyles } from './styles';

interface SelectQuestionProps {
  question: SelectQuestionType;
  selectedValues?: string[];
  onSelect: (values: string[]) => void;
}

const SelectQuestion: React.FC<SelectQuestionProps> = ({
  question,
  selectedValues = [],
  onSelect,
}) => {
  const classes = useStyles();

  const optionsWithAllOptions = question.multiselect
    ? [{ id: 'all-options', text: 'All Options' }, ...question.options]
    : question.options;

  const regularOptionIds = question.options.map((option) => option.id);

  const handleOptionChange = (optionId: string) => {
    let newSelectedValues: string[];

    if (question.multiselect) {
      if (optionId === 'all-options') {
        const isAllSelected = regularOptionIds.every((id) =>
          selectedValues.includes(id),
        );
        if (isAllSelected) {
          newSelectedValues = [];
        } else {
          newSelectedValues = [...regularOptionIds];
        }
      } else {
        if (selectedValues.includes(optionId)) {
          newSelectedValues = selectedValues.filter((id) => id !== optionId);
        } else {
          newSelectedValues = [...selectedValues, optionId];
        }
      }
    } else {
      newSelectedValues = selectedValues.includes(optionId) ? [] : [optionId];
    }

    onSelect(newSelectedValues);
  };

  const leftColumn = optionsWithAllOptions.slice(
    0,
    Math.ceil(optionsWithAllOptions.length / 2),
  );
  const rightColumn = optionsWithAllOptions.slice(
    Math.ceil(optionsWithAllOptions.length / 2),
  );

  return (
    <Box sx={classes.container}>
      <Box sx={classes.columnsContainer}>
        <Box sx={classes.column}>
          {leftColumn.map((option) => {
            const isAllOptionsButton = option.id === 'all-options';
            const isChecked = isAllOptionsButton
              ? regularOptionIds.every((id) => selectedValues.includes(id))
              : selectedValues.includes(option.id);

            return (
              <Box
                key={option.id}
                sx={classes.optionRow}
                onClick={() => handleOptionChange(option.id)}
              >
                <Checkbox checked={isChecked} sx={classes.checkbox} />
                <Typography sx={classes.optionText}>{option.text}</Typography>
              </Box>
            );
          })}
        </Box>

        <Box sx={classes.columnDivider} />

        <Box sx={classes.column}>
          {rightColumn.map((option) => {
            const isAllOptionsButton = option.id === 'all-options';
            const isChecked = isAllOptionsButton
              ? regularOptionIds.every((id) => selectedValues.includes(id))
              : selectedValues.includes(option.id);

            return (
              <Box
                key={option.id}
                sx={classes.optionRow}
                onClick={() => handleOptionChange(option.id)}
              >
                <Checkbox checked={isChecked} sx={classes.checkbox} />
                <Typography sx={classes.optionText}>{option.text}</Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default SelectQuestion;
